import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';

import { STATIC_PAGES } from '@app/content/data';

@Injectable({
  providedIn: 'root'
})
export class ContentService {
  public fetchContent<T>(slug: string): Observable<T> {
    return of(STATIC_PAGES[slug]);
  }
}
